import React from "react";
import {
  Row,
  Col,
  Breadcrumb,
  DropdownButton,
  Dropdown,
  Form,
  Button,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation/Navigation";
import Footer from "./Footer/Footer";
import * as Icon from "react-feather";
import firebase from "../Utils/Firebase";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.min.css";
import User from "../model/User";
import styled from "styled-components";
import UploadImage from "../components/UploadImage";
import { updateProfileImage } from "../supporting_files/Data";
class Profile extends React.Component {
  state = {
    sideMenu: true,
    user: User.getInstance().selectedUser,
    requests: [],
    notificationTitle: "",
    notificationBody: "",
    mondayOpen: User.getInstance().selectedUser.mondayOpen,
    mondayClose: User.getInstance().selectedUser.mondayClose,
    tuesdayOpen: User.getInstance().selectedUser.tuesdayOpen,
    tuesdayClose: User.getInstance().selectedUser.tuesdayClose,
    wednesdayOpen: User.getInstance().selectedUser.wednesdayOpen,
    wednesdayClose: User.getInstance().selectedUser.wednesdayClose,
    thursdayOpen: User.getInstance().selectedUser.thursdayOpen,
    thursdayClose: User.getInstance().selectedUser.thursdayClose,
    fridayOpen: User.getInstance().selectedUser.fridayOpen,
    fridayClose: User.getInstance().selectedUser.fridayClose,
    saturdayOpen: User.getInstance().selectedUser.saturdayOpen,
    saturdayClose: User.getInstance().selectedUser.saturdayClose,
    sundayOpen: User.getInstance().selectedUser.sundayOpen,
    sundayClose: User.getInstance().selectedUser.sundayClose,
    latitude: User.getInstance().selectedUser.latitude,
    longitude: User.getInstance().selectedUser.longitude,
    pictureURL: User.getInstance().selectedUser.pictureURL,
    videoURL: User.getInstance().selectedUser.videoURL,
    pictures: User.getInstance().selectedUser.pictures,
    pictureCaptions: User.getInstance().selectedUser.pictureCaptions,
    amenities: User.getInstance().selectedUser.amenities,
    established: User.getInstance().selectedUser.established,
    nearbyTitles: User.getInstance().selectedUser.nearbyTitles,
    nearbyService: User.getInstance().selectedUser.nearbyService,
    nearbyDistance: User.getInstance().selectedUser.nearbyDistance,
    nearbyImage: User.getInstance().selectedUser.nearbyImage,
    serviceTitles: User.getInstance().selectedUser.serviceTitles,
    servicePrices: User.getInstance().selectedUser.servicePrices,
    serviceDurations: User.getInstance().selectedUser.serviceDurations,
    teamNames: User.getInstance().selectedUser.teamNames,
    teamPictures: User.getInstance().selectedUser.teamPictures,
    teamBios: User.getInstance().selectedUser.teamBios,
    paymentMethod: User.getInstance().selectedUser.paymentMethod,
    filenameVideo: "No Video Attached",
    fileVideo: null,
    showDeleteVideo: false,
    ethnicities: User.getInstance().selectedUser.ethnicities,
    subscriptionType: User.getInstance().selectedUser.subscriptionType,
    fullName: User.getInstance().selectedUser.fullName,
    email: User.getInstance().selectedUser.email,
    phoneNumber: User.getInstance().selectedUser.phoneNumber,
    shopNumber: User.getInstance().selectedUser.shopNumber,
    shopName: User.getInstance().selectedUser.shopName,
    shopAddress: User.getInstance().selectedUser.shopAddress,
    wantVoucher: User.getInstance().selectedUser.wantVoucher,
    isTrimItBarber: User.getInstance().selectedUser.isTrimItBarber,
    websiteUrl: User.getInstance().selectedUser.websiteUrl,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    if (!User.getInstance().selectedUser) {
      window.location.href = "/";
    }
  }

  // Toggle side bar menu
  _onSideMenu = (active) => {
    this.setState({ sideMenu: active });
  };

  inputChanged(value) {
    this.setState({
      filenameVideo: document.getElementById("inputGroupFile01").files[0].name,
      fileVideo: document.getElementById("inputGroupFile01").files[0],
      showDeleteVideo: true,
    });
  }

  removeAttachment() {
    document.getElementById("inputGroupFile01").value = "";
    this.setState({
      filenameVideo: "No File Attached",
      fileVideo: null,
      showDeleteVideo: false,
    });
  }

  changeStatus(status) {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({ display: status })
      .then((result) => {
        window.location.reload();
      });
  }

  wantVoucher(status) {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({ wantVoucher: status })
      .then((result) => {
        this.setState({ wantVoucher: status})
      });
  }

  isTrimItBarber(status) {
    firebase
        .firestore()
        .collection("salons")
        .doc(this.state.user.uid)
        .update({ isTrimItBarber: status })
        .then((result) => {
          this.setState({ isTrimItBarber: status})
        });
  }

  changeSubscriptionType(type) {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({ subscriptionType: type })
      .then((result) => {
        window.location.reload();
      });
  }

  changeCard(card) {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({ paymentMethod: card })
      .then((result) => {
        window.location.reload();
      });
  }

  changeTeams() {
    let teamNames = this.state.teamNames.split(",");
    let teamPictures = this.state.teamPictures.split(",");
    let teamBios = this.state.teamBios.split(",");

    if (
      teamNames.length !== teamPictures.length ||
      teamNames.length !== teamBios.length
    ) {
      alert(
        "Error! There are " +
          teamNames.length +
          " Names, " +
          teamPictures.length +
          " Pictures, and " +
          teamBios.length +
          " Bios"
      );
    } else {
      firebase
        .firestore()
        .collection("salons")
        .doc(this.state.user.uid)
        .update({
          teamNames: this.state.teamNames.split(","),
          teamPictures: this.state.teamPictures.split(","),
          teamBios: this.state.teamBios.split("@"),
        })
        .then((result) => {
          window.location.reload();
        });
    }
  }

  changeServices() {
    let serviceTitles = this.state.serviceTitles.split(",");
    let servicePrices = this.state.servicePrices.split(",");
    let serviceDurations = this.state.serviceDurations.split(",");

    if (
      serviceTitles.length !== servicePrices.length ||
      serviceTitles.length !== serviceDurations.length
    ) {
      alert(
        "Error! There are " +
          serviceTitles.length +
          " title, " +
          servicePrices.length +
          " prices, and " +
          serviceDurations.length +
          " durations"
      );
    } else {
      firebase
        .firestore()
        .collection("salons")
        .doc(this.state.user.uid)
        .update({
          serviceTitles: serviceTitles,
          servicePrices: servicePrices,
          serviceDurations: serviceDurations,
        })
        .then((result) => {
          window.location.reload();
        });
    }
  }

  changeNearby() {
    let nearbyTitles = this.state.nearbyTitles.split(",");
    let nearbyService = this.state.nearbyService.split(",");
    let nearbyDistance = this.state.nearbyDistance.split(",");

    if (
      nearbyTitles.length !== nearbyService.length ||
      nearbyTitles.length !== nearbyDistance.length
    ) {
      alert(
        "Error! There are " +
          nearbyTitles.length +
          " titles, " +
          nearbyService.length +
          " services, and " +
          nearbyDistance.length +
          " distances"
      );
    } else {
      firebase
        .firestore()
        .collection("salons")
        .doc(this.state.user.uid)
        .update({
          nearbyTitles: this.state.nearbyTitles.split(","),
          nearbyService: this.state.nearbyService.split(","),
          nearbyDistance: this.state.nearbyDistance.split(","),
          nearbyImage: this.state.nearbyImage,
        })
        .then((result) => {
          window.location.reload();
        });
    }
  }

  changeAmenities() {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({
        amenities: this.state.amenities.split(","),
      })
      .then((result) => {
        window.location.reload();
      });
  }

  changePictures() {
    let pictures = this.state.pictures.split(",");
    let pictureCaptions = this.state.pictureCaptions.split(",");

    if (pictures.length !== pictureCaptions.length) {
      alert(
        "Error! There are " +
          pictures.length +
          " pictures, and " +
          pictureCaptions.length +
          " captions"
      );
    } else {
      firebase
        .firestore()
        .collection("salons")
        .doc(this.state.user.uid)
        .update({
          pictureURL: this.state.pictureURL,
          pictures: pictures,
          pictureCaptions: pictureCaptions,
          established: this.state.established,
          ethnicities: this.state.ethnicities.split(","),
        })
        .then((result) => {
          window.location.reload();
        });
    }
  }
  changeBarberURL() {
    firebase
        .firestore()
        .collection("salons")
        .doc(this.state.user.uid)
        .update({
          websiteUrl: this.state.websiteUrl,
        })
        .then((result) => {
          window.location.reload();
        });
  }

  changeVideo() {
    let app = this;
    let ref = firebase.storage();
    let uid = Math.random()
      .toString(36)
      .substring(7);
    ref = ref.ref().child("videos/" + uid + ".mp4");
    var uploadTask = ref.put(app.state.fileVideo);

    uploadTask.on(
      "state_changed",
      function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      function(error) {
        console.log(error);
      },
      function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log("File available at", downloadURL);

          firebase
            .firestore()
            .collection("salons")
            .doc(app.state.user.uid)
            .update({
              videoURL: downloadURL,
            })
            .then((result) => {
              window.location.reload();
            });
        });
      }
    );
  }

  changeLocation() {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({
        longitude: this.state.longitude,
        latitude: this.state.latitude,
      })
      .then((result) => {
        window.location.reload();
      });
  }
  changeTimes() {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({
        openingTimes: {
          monday: this.state.mondayOpen,
          tuesday: this.state.tuesdayOpen,
          wednesday: this.state.wednesdayOpen,
          thursday: this.state.thursdayOpen,
          friday: this.state.fridayOpen,
          saturday: this.state.saturdayOpen,
          sunday: this.state.sundayOpen,
        },
        closingTimes: {
          monday: this.state.mondayClose,
          tuesday: this.state.tuesdayClose,
          wednesday: this.state.wednesdayClose,
          thursday: this.state.thursdayClose,
          friday: this.state.fridayClose,
          saturday: this.state.saturdayClose,
          sunday: this.state.sundayClose,
        },
      })
      .then((result) => {
        window.location.reload();
      });
  }

  sendNotification() {
    let App = this;
    let title = this.state.notificationTitle;
    let body = this.state.notificationBody;
    let token = User.getInstance()._selectedUser.pushToken;
    var send = firebase.functions().httpsCallable("sendCustomNotification");

    send({ title: title, body: body, token: token }).then(function(result) {
      firebase
        .firestore()
        .collection("config")
        .doc("logs")
        .collection(User.getInstance()._selectedUser.uid)
        .add({
          title: title,
          body: body,
          token: token,
          timestamp: new Date(),
          sender: User.getInstance()._userEmail,
        });
      alert(result.data);
    });
  }

  updateMainDetails() {
    firebase
      .firestore()
      .collection("salons")
      .doc(this.state.user.uid)
      .update({
        fullName: this.state.fullName,
        phoneNumber: this.state.phoneNumber,
        shopName: this.state.shopName,
        shopNumber: this.state.shopNumber,
        shopAddress: this.state.shopAddress,
      })
      .then((result) => {
        window.location.reload();
      });
  }
  // async function asyncCall() {
  //   console.log('calling');
  //   const result = await resolveAfter2Seconds();
  //   console.log(result);
  //   // expected output: "resolved"
  // }

  async bulkUpdate() {
    const db = firebase.firestore()
    const limit = 50
    // let itemsCollection = db.collection("items")
    
    //let allItemsResult = await itemsCollection.limit(limit).get()
    //let read = allItemsResult.docs.length
    let saloonCollections = firebase.firestore().collection("salons").limit(limit).get()
     let read1 = saloonCollections.docs.length
    while (read1 > 0){
      let batch = firebase.firestore.batch()
      let updated = 0
      saloonCollections.docs.forEach((queryResult) => {
        const doc = queryResult.data()
        if (!doc.isTrimItBarber){
          updated++

          batch.update(queryResult.ref, {
            isTrimItBarber: true
          })
        }
      })
      await batch.commit()
      console.log(`Updated ${updated} of ${read1} items!`)
    }
  
    // while (read > 0) {
    //   const batch = db.batch()
    //   let updated = 0
  
    //   allItemsResult.docs.forEach((queryResult) => {
    //     const doc = queryResult.data()
  
    //     if (!doc.dateUnix) {
    //       updated++
  
    //       batch.update(queryResult.ref, {
    //         // getTime() returns milliseconds
    //         // We convert to seconds and remove any fractional part
    //         dateUnix: (doc.date.toDate().getTime() / 1000) | 0,
    //       })
    //     }
    //   })
    // }
  
    // await batch.commit()
    // console.log(`Updated ${updated} of ${read} items!`)
  }

  render() {
    return (
      <div className="page-wrapper">
        <Icon.ArrowRight id="arrowIcon" className="icon" />
        {/* Navigation */}
        <Navigation onClick={this._onSideMenu} />
        {/* End Navigation */}

        <div className="">
          <button onClick={this.bulkUpdate}>Bulk Update</button>
        </div>

        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          {/* Breadcrumb */}
          <div className="main-content-header">
            <Breadcrumb>
              <h1>Profile</h1>
              <Link to="/dashboard" className="breadcrumb-item">
                Dashboard
              </Link>
              <Breadcrumb.Item active>Profile</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Row>
            <Col lg={12}>
              <div className="profile-header mb-4">
                <h1 className="name mt-3">
                  {this.state.user.package
                    ? this.state.user.shopName
                    : "Unlisted Barbershop"}
                </h1>
              </div>
            </Col>

            <Col lg="5">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Info</h5>
                    </div>
                    <ul className="info">
                      <li>
                        <Icon.MapPin className="icon" />
                        <label style={{ width: 100 }}>User Id:</label>{" "}
                        {this.state.user.uid + ""}
                      </li>
                      <li>
                        <Icon.User className="icon" />
                        <label style={{ width: 100 }}>Fullname:</label>{" "}
                        <input
                          type="text"
                          value={this.state.fullName}
                          onChange={(e) =>
                            this.setState({ fullName: e.target.value })
                          }
                        />
                      </li>
                      <li>
                        <Icon.Mail className="icon" />
                        <label style={{ width: 100 }}>Email:</label>{" "}
                        {this.state.user.email + ""}
                      </li>
                      <li>
                        <Icon.Phone className="icon" />
                        <label style={{ width: 100 }}>
                          Contact Number:
                        </label>{" "}
                        <input
                          type="text"
                          value={this.state.phoneNumber}
                          onChange={(e) =>
                            this.setState({ phoneNumber: e.target.value })
                          }
                        />
                      </li>
                      <li>
                        <Icon.Calendar className="icon" />
                        <label style={{ width: 100 }}>Member Since:</label>{" "}
                        {this.state.user.creationDate + ""}
                      </li>
                      <li>
                        <Icon.Scissors className="icon" />
                        <label style={{ width: 100 }}>Shop Name:</label>{" "}
                        <input
                          type="text"
                          value={this.state.shopName}
                          onChange={(e) =>
                            this.setState({ shopName: e.target.value })
                          }
                        />
                      </li>
                      <li>
                        <Icon.Phone className="icon" />
                        <label style={{ width: 100 }}>Shop Number:</label>{" "}
                        <input
                          type="text"
                          value={this.state.shopNumber}
                          onChange={(e) =>
                            this.setState({ shopNumber: e.target.value })
                          }
                        />
                      </li>
                      <li>
                        <Icon.MapPin className="icon" />
                        <label style={{ width: 100 }}>Shop Address:</label>{" "}
                        <input
                          type="text"
                          value={this.state.shopAddress}
                          onChange={(e) =>
                            this.setState({ shopAddress: e.target.value })
                          }
                        />
                      </li>
                      <li>
                        <Icon.Package className="icon" />
                        <label style={{ width: 100 }}>Package:</label>{" "}
                        {this.state.user.package + ""}
                      </li>
                      <li>
                        <Icon.DollarSign className="icon" />
                        <label style={{ width: 100 }}>
                          transaction Id:
                        </label>{" "}
                        {this.state.user.transactionId + ""}
                      </li>
                      <li>
                        <Icon.Calendar className="icon" />
                        <label style={{ width: 100 }}>
                          transaction Date:
                        </label>{" "}
                        {this.state.user.transactionDate + ""}
                      </li>
                    </ul>
                    <Button
                      onClick={() => this.updateMainDetails()}
                      style={{
                        marginTop: 32,

                        marginBottom: 16,
                        width: 200,
                        borderStyle: "none",
                        borderRadius: 10,
                        backgroundColor: "green",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="3">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Profile Image:</h5>
                    </div>
                    <UploadImage
                      id="profileImage"
                      self={this}
                      multiple={false}
                      type="profileImage"
                      accept="image/*"
                    />
                    <Button
                      onClick={() => {
                        if (this.state.profileImage) {
                          updateProfileImage(
                            this.state.profileImage,
                            this.state.user.uid
                          );
                        }
                      }}
                      style={{
                        marginTop: 32,

                        marginBottom: 16,
                        width: 200,
                        borderStyle: "none",
                        borderRadius: 10,
                        backgroundColor: "green",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                    <div>
                      <h5 className="card-title">Has opt in to voucher promo: </h5>
                      <DropdownButton
                          id="dropdown-basic-button"
                          title={this.state.wantVoucher ? "Yes" : "No"}
                          variant={
                            this.state.wantVoucher ? "success" : "danger"
                          }
                        >
                          <Dropdown.Item
                            onClick={() => this.wantVoucher(true)}
                          >
                            Yes
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => this.wantVoucher(false)}
                          >
                            No
                          </Dropdown.Item>
                        </DropdownButton>
                      </div>
                    <div style={{marginTop: '10px'}}>
                      <h5 className="card-title">Is trim-it barber: </h5>
                      <DropdownButton
                          id="dropdown-basic-button"
                          title={this.state.isTrimItBarber ? "Yes" : "No"}
                          variant={
                            this.state.isTrimItBarber ? "success" : "danger"
                          }
                      >
                        <Dropdown.Item
                            onClick={() => this.isTrimItBarber(true)}
                        >
                          Yes
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => this.isTrimItBarber(false)}
                        >
                          No
                        </Dropdown.Item>
                      </DropdownButton>
                    </div>
                    {this.state.isTrimItBarber &&
                    <>
                      <div style={{ marginTop: 20}}>
                        <label >Barbershop Website Link (edit to update and click update button below)</label><br/>
                        <input
                            type="text"
                            placeholder="Barber website link"
                            value={this.state.websiteUrl}
                            onChange={(event) =>
                                this.setState({ websiteUrl: event.target.value })
                            }
                        />
                      </div>
                        <div
                        style={{
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                        >
                          <button
                            onClick={() => this.changeBarberURL()}
                            style={{
                              marginTop: 32,

                              marginBottom: 16,
                              width: 200,
                              borderStyle: "none",
                              borderRadius: 10,
                              backgroundColor: "green",
                              color: "white",
                            }}
                          >
                            Update barber website link
                          </button>
                        </div>
                        </>
                      }
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="5">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Pictures / General Info</h5>
                    </div>
                    <Row>
                      <Row style={{ marginLeft: 16, width: 250 }}>
                        <Icon.Image
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>Profile Image URL:</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="picutre url..."
                          value={this.state.pictureURL}
                          onChange={(event) =>
                            this.setState({ pictureURL: event.target.value })
                          }
                        />
                      </Row>
                    </Row>

                    <Row style={{ marginTop: 16 }}>
                      <Row style={{ marginLeft: 16, width: 250 }}>
                        <Icon.Image
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>All Pictures (separate by comma):</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="seperate by comma ,"
                          value={this.state.pictures}
                          onChange={(event) =>
                            this.setState({ pictures: event.target.value })
                          }
                        />
                      </Row>
                    </Row>
                    <Row style={{ marginTop: 16 }}>
                      <Row style={{ marginLeft: 16, width: 250 }}>
                        <Icon.Image
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>Picture Captions (,):</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="seperate by comma ,"
                          value={this.state.pictureCaptions}
                          onChange={(event) =>
                            this.setState({
                              pictureCaptions: event.target.value,
                            })
                          }
                        />
                      </Row>
                    </Row>
                    <Row style={{ marginTop: 16 }}>
                      <Row style={{ marginLeft: 16, width: 250 }}>
                        <Icon.Calendar
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>Established:</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="established label..."
                          value={this.state.established}
                          onChange={(event) =>
                            this.setState({ established: event.target.value })
                          }
                        />
                      </Row>
                    </Row>
                    <Row style={{ marginTop: 16 }}>
                      <Row style={{ marginLeft: 16, width: 250 }}>
                        <Icon.Users
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>Ethnicities (,):</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="ethnicities (,)"
                          value={this.state.ethnicities}
                          onChange={(event) =>
                            this.setState({ ethnicities: event.target.value })
                          }
                        />
                      </Row>
                    </Row>

                    <div
                      style={{
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <button
                        onClick={() => this.changePictures()}
                        style={{
                          marginTop: 32,

                          marginBottom: 16,
                          width: 200,
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="2">
              <div className="profile-right-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Actions</h5>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <div>
                        <DropdownButton
                          id="dropdown-basic-button"
                          title={this.state.user.display ? "Live" : "Inactive"}
                          variant={
                            this.state.user.display ? "success" : "danger"
                          }
                        >
                          <Dropdown.Item
                            onClick={() => this.changeStatus(true)}
                          >
                            Live
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => this.changeStatus(false)}
                          >
                            Inactive
                          </Dropdown.Item>
                        </DropdownButton>
                      </div>

                      <div style={{ marginTop: 16 }}>
                        <DropdownButton
                          id="dropdown-basic-button"
                          title={
                            this.state.subscriptionType
                              ? this.state.subscriptionType
                              : "normal"
                          }
                          variant={"info"}
                        >
                          <Dropdown.Item
                            onClick={() =>
                              this.changeSubscriptionType("normal")
                            }
                          >
                            Normal Account
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => this.changeSubscriptionType("free")}
                          >
                            Free Basic Package
                          </Dropdown.Item>
                        </DropdownButton>
                      </div>

                      <div style={{ marginTop: 16 }}>
                        <DropdownButton
                          id="dropdown-basic-button"
                          title={this.state.paymentMethod}
                          variant={"info"}
                        >
                          <Dropdown.Item
                            onClick={() => this.changeCard("Cash payment only")}
                          >
                            Cash payment only
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => this.changeCard("Card payment only")}
                          >
                            Card payment only
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              this.changeCard("Cash & Card payment available")
                            }
                          >
                            Cash & Card payment available
                          </Dropdown.Item>
                        </DropdownButton>
                      </div>

                      <div style={{ marginTop: 16 }}>
                        <Popup
                          trigger={
                            <button
                              style={{
                                borderStyle: "none",
                                borderRadius: 10,
                                height: 30,
                                backgroundColor: "green",
                                color: "white",
                              }}
                            >
                              Send Notification
                            </button>
                          }
                          position="bottom"
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <TitleInput
                              style={{ width: 150, marginTop: 16 }}
                              onChange={(e) =>
                                this.setState({
                                  notificationTitle: e.target.value,
                                })
                              }
                              placeholder="Enter the title here"
                            />

                            <BodyInput
                              style={{ width: 150, marginTop: 16 }}
                              onChange={(e) =>
                                this.setState({
                                  notificationBody: e.target.value,
                                })
                              }
                              placeholder="Enter the body here"
                            />
                            <SendButton
                              style={{
                                marginTop: 16,
                                borderStyle: "none",
                                borderRadius: 10,
                                backgroundColor: "green",
                                color: "white",
                              }}
                              onClick={() => this.sendNotification()}
                            >
                              Send
                            </SendButton>
                          </div>
                        </Popup>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="2">
              <div className="profile-right-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Amenities</h5>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Row>
                        <input
                          type="text"
                          placeholder="seperate by comma ,"
                          value={this.state.amenities}
                          onChange={(event) =>
                            this.setState({ amenities: event.target.value })
                          }
                        />
                      </Row>

                      <button
                        onClick={() => this.changeAmenities()}
                        style={{
                          marginTop: 16,
                          marginBottom: 16,
                          width: "80%",
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="6">
              <div className="profile-middle-content mb-4">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Opening / Closing Times</h5>
                    </div>
                    <Row
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <Row style={{ marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Monday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.mondayOpen}
                            onChange={(event) =>
                              this.setState({ mondayOpen: event.target.value })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Monday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.mondayClose}
                            onChange={(event) =>
                              this.setState({ mondayClose: event.target.value })
                            }
                          />
                        </Row>
                      </Row>
                      <Row style={{ marginTop: 16, marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Tuesday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.tuesdayOpen}
                            onChange={(event) =>
                              this.setState({ tuesdayOpen: event.target.value })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Tuesday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.tuesdayClose}
                            onChange={(event) =>
                              this.setState({
                                tuesdayClose: event.target.value,
                              })
                            }
                          />
                        </Row>
                      </Row>
                      <Row style={{ marginTop: 16, marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Wednesday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.wednesdayOpen}
                            onChange={(event) =>
                              this.setState({
                                wednesdayOpen: event.target.value,
                              })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Wednesday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.wednesdayClose}
                            onChange={(event) =>
                              this.setState({
                                wednesdayClose: event.target.value,
                              })
                            }
                          />
                        </Row>
                      </Row>
                      <Row style={{ marginTop: 16, marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Thursday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.thursdayOpen}
                            onChange={(event) =>
                              this.setState({
                                thursdayOpen: event.target.value,
                              })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Thursday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.thursdayClose}
                            onChange={(event) =>
                              this.setState({
                                thursdayClose: event.target.value,
                              })
                            }
                          />
                        </Row>
                      </Row>
                      <Row style={{ marginTop: 16, marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Friday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.fridayOpen}
                            onChange={(event) =>
                              this.setState({ fridayOpen: event.target.value })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Friday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.fridayClose}
                            onChange={(event) =>
                              this.setState({ fridayClose: event.target.value })
                            }
                          />
                        </Row>
                      </Row>
                      <Row style={{ marginTop: 16, marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Saturday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.saturdayOpen}
                            onChange={(event) =>
                              this.setState({
                                saturdayOpen: event.target.value,
                              })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Saturday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.saturdayClose}
                            onChange={(event) =>
                              this.setState({
                                saturdayClose: event.target.value,
                              })
                            }
                          />
                        </Row>
                      </Row>
                      <Row style={{ marginTop: 16, marginRight: 8 }}>
                        <Row style={{ marginLeft: 16, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Sunday Open:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.sundayOpen}
                            onChange={(event) =>
                              this.setState({ sundayOpen: event.target.value })
                            }
                          />
                        </Row>
                        <Row style={{ marginLeft: 64, width: 150 }}>
                          <Icon.Calendar
                            className="icon"
                            style={{ marginRight: 8 }}
                          />
                          <label>Sunday Close:</label>
                        </Row>
                        <Row style={{ marginLeft: 32 }}>
                          <input
                            type="text"
                            placeholder="SECONDS ONLY"
                            value={this.state.sundayClose}
                            onChange={(event) =>
                              this.setState({ sundayClose: event.target.value })
                            }
                          />
                        </Row>
                      </Row>
                    </Row>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      onClick={() => this.changeTimes()}
                      style={{
                        marginBottom: 16,
                        width: 200,
                        borderStyle: "none",
                        borderRadius: 10,
                        backgroundColor: "green",
                        color: "white",
                      }}
                    >
                      Set Times
                    </button>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="3">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Location</h5>
                    </div>
                    <Row>
                      <Row style={{ marginLeft: 16, width: 100 }}>
                        <Icon.MapPin
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>Longitude:</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="Longitude..."
                          value={this.state.longitude}
                          onChange={(event) =>
                            this.setState({ longitude: event.target.value })
                          }
                        />
                      </Row>
                    </Row>
                    <Row style={{ marginTop: 16 }}>
                      <Row style={{ marginLeft: 16, width: 100 }}>
                        <Icon.MapPin
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>Latitude:</label>
                      </Row>
                      <Row style={{ marginLeft: 32 }}>
                        <input
                          type="text"
                          placeholder="Latitude..."
                          value={this.state.latitude}
                          onChange={(event) =>
                            this.setState({ latitude: event.target.value })
                          }
                        />
                      </Row>
                    </Row>
                    <div
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <button
                        onClick={() => this.changeLocation()}
                        style={{
                          marginTop: 16,

                          marginBottom: 16,
                          width: 200,
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        Set Location
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="2">
              <div className="profile-right-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Nearby</h5>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Row>
                        <input
                          type="text"
                          placeholder="Nearby Titles (,)"
                          value={this.state.nearbyTitles}
                          onChange={(event) =>
                            this.setState({ nearbyTitles: event.target.value })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Nearby Ditances (,)"
                          value={this.state.nearbyDistance}
                          onChange={(event) =>
                            this.setState({
                              nearbyDistance: event.target.value,
                            })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Nearby Info (,)"
                          value={this.state.nearbyService}
                          onChange={(event) =>
                            this.setState({ nearbyService: event.target.value })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Image URL"
                          value={this.state.nearbyImage}
                          onChange={(event) =>
                            this.setState({ nearbyImage: event.target.value })
                          }
                        />
                      </Row>
                      <button
                        onClick={() => this.changeNearby()}
                        style={{
                          marginTop: 16,
                          marginBottom: 16,
                          width: "80%",
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="2">
              <div className="profile-right-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Services</h5>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Row>
                        <input
                          type="text"
                          placeholder="Service Titles (,)"
                          value={this.state.serviceTitles}
                          onChange={(event) =>
                            this.setState({ serviceTitles: event.target.value })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Service Prices (,)"
                          value={this.state.servicePrices}
                          onChange={(event) =>
                            this.setState({
                              servicePrices: event.target.value,
                            })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Service Durations (,)"
                          value={this.state.serviceDurations}
                          onChange={(event) =>
                            this.setState({
                              serviceDurations: event.target.value,
                            })
                          }
                        />
                      </Row>
                      <button
                        onClick={() => this.changeServices()}
                        style={{
                          marginTop: 16,
                          marginBottom: 16,
                          width: "80%",
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="2">
              <div className="profile-right-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Teams</h5>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Row>
                        <input
                          type="text"
                          placeholder="Team Names (,)"
                          value={this.state.teamNames}
                          onChange={(event) =>
                            this.setState({ teamNames: event.target.value })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Team Pictures (,)"
                          value={this.state.teamPictures}
                          onChange={(event) =>
                            this.setState({
                              teamPictures: event.target.value,
                            })
                          }
                        />
                      </Row>
                      <Row style={{ marginTop: 16 }}>
                        <input
                          type="text"
                          placeholder="Team Bios (@)"
                          value={this.state.teamBios}
                          onChange={(event) =>
                            this.setState({
                              teamBios: event.target.value,
                            })
                          }
                        />
                      </Row>
                      <button
                        onClick={() => this.changeTeams()}
                        style={{
                          marginTop: 16,
                          marginBottom: 16,
                          width: "80%",
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="5">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Video</h5>
                    </div>
                    <Row style={{ marginTop: 16 }}>
                      <Row style={{ marginLeft: 16, width: 250 }}>
                        <Icon.Video
                          className="icon"
                          style={{ marginRight: 8 }}
                        />
                        <label>MP4 ONLY:</label>
                      </Row>
                      <div
                        style={{
                          width: 250,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        className="input-group"
                      >
                        <div className="custom-file">
                          <input
                            type="file"
                            onChange={(value) => this.inputChanged(value)}
                            className="custom-file-input"
                            id="inputGroupFile01"
                            accept="video/mp4"
                            aria-describedby="inputGroupFileAddon01"
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            {this.state.filenameVideo}
                          </label>
                        </div>

                        <div
                          onClick={() => this.removeAttachment()}
                          style={{
                            opacity: this.state.showDeleteVideo ? 1 : 0,
                            marginLeft: 16,
                            backgroundColor: "lightgrey",
                            width: 20,
                            height: 20,
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 10,
                          }}
                        >
                          X
                        </div>
                      </div>
                    </Row>
                    <div
                      style={{
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <button
                        onClick={() => this.changeVideo()}
                        style={{
                          marginTop: 32,

                          marginBottom: 16,
                          width: 200,
                          borderStyle: "none",
                          borderRadius: 10,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        {this.state.user.videoURL
                          ? "Change existing Video"
                          : "Add Video"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <div className="flex-grow-1" />
          <Footer />
        </div>
      </div>
    );
  }
}

export const dateConverter = (UNIX_timestamp) => {
  var a = new Date(UNIX_timestamp * 1000);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = date + " " + month + " " + year;
  return time;
};

export default Profile;

const TitleInput = styled.input``;
const BodyInput = styled.textarea``;
const SendButton = styled.button``;
const Label = styled.h3`
  margin-right: 16px;
`;
